module.exports = __webpack_public_path__ + "img/audio_play--btn.b59f6716.svg";